// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scale-reduce[data-v-6cdbf010] {\n  -webkit-transform: scale(0.725);\n          transform: scale(0.725);\n  -webkit-transform-origin: 50% 50%;\n          transform-origin: 50% 50%;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
